import { render } from "./CountdownTimer.vue?vue&type=template&id=1c811066&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&lang=js"

import "./CountdownTimer.vue?vue&type=style&index=0&id=1c811066&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c811066"]])

export default __exports__